module.exports = __webpack_public_path__ + "static/img/IMG_20240210_144155.2d74616e.jpg";